import React, { lazy, useMemo } from 'react';
import SuspenseWrapper from '@/components/SuspenseWrapper.tsx';
import MainLayout from '@/layouts/MainLayout';
import ErrorBoundary from '@/components/ErrorBoundary';
import { SessionInitializer } from '@/components/SessionInitializer';
import { getUtmTagsFromUrl } from '@/utils/utm';

const LazyCopyPasteTracker = lazy(() => import('@/components/CopyPasteTracker'));

const GetStartedLayout = ({ children }: { children: React.ReactNode }) => {
  const utmTags = useMemo(() => JSON.stringify(getUtmTagsFromUrl()), []);

  return (
    <MainLayout>
      <SessionInitializer utmTags={utmTags} />
      <SuspenseWrapper fallbackClassName="h-0 w-0 opacity-0">
        <LazyCopyPasteTracker />
      </SuspenseWrapper>
      <ErrorBoundary>
        <SuspenseWrapper fallbackClassName="min-h-screen w-full bg-primary-light !rounded-none !animate-none">
          <div className="w-full">{children}</div>
        </SuspenseWrapper>
      </ErrorBoundary>
    </MainLayout>
  );
};

export default GetStartedLayout;
